import { Music2 } from "lucide-react";

export default function Header() {
  const goToForm = () => {
    const el = document.getElementById("inscription");
    if (window.__lenis && el) window.__lenis.scrollTo(el, { offset: -80 });
    else el?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl backdrop-saturate-150 bg-[#FDFBF7]/80 border-b border-[#E8DCD0]"
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <a href="/" data-testid="brand-link" className="flex items-center gap-3">
          <span className="w-9 h-9 rounded-full bg-[#D95D39] text-[#FDFBF7] flex items-center justify-center">
            <Music2 className="w-4 h-4" />
          </span>
          <span className="font-display font-bold text-lg tracking-tight leading-none">
            CMC<span className="text-[#D95D39]">-</span>Belgique
            <span className="block text-[10px] font-sans font-semibold uppercase tracking-[0.2em] text-[#5C4A3D] mt-0.5">
              Conservatoire de la Musique Chrétienne
            </span>
          </span>
        </a>
        <button
          data-testid="header-cta-button"
          onClick={goToForm}
          className="rounded-full bg-[#2C1E16] text-[#FDFBF7] px-6 py-2.5 text-sm font-semibold transition-[transform,background-color] duration-300 hover:scale-105 hover:bg-[#D95D39]"
        >
          Je réserve ma place
        </button>
      </div>
    </header>
  );
}
